import { QRCodeSVG } from 'qrcode.react';
import { CARD_W, CARD_H } from './cardSize';

export default function FloralPink({ data, style }) {
  const { groomName, brideName, date, time, venue, address, message: msg, qrValue } = data || {};

  return (
    <div
      className="inv-card"
      style={{
        width: CARD_W, height: CARD_H,
        background: 'linear-gradient(160deg, #FFF0F5, #FDE8F0, #FFF5F8)',
        border: '2.5px solid #F8BBD0',
        borderRadius: 16,
        padding: '8mm 8mm',
        fontFamily: "'Segoe UI', 'Helvetica Neue', sans-serif",
        color: '#880E4F',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {/* Flower corners */}
      <div style={{ position: 'absolute', top: -4, left: -4, fontSize: 28, opacity: 0.35 }}>🌸</div>
      <div style={{ position: 'absolute', top: -4, right: -4, fontSize: 28, opacity: 0.35 }}>🌷</div>
      <div style={{ position: 'absolute', bottom: -4, left: -4, fontSize: 28, opacity: 0.35 }}>🌹</div>
      <div style={{ position: 'absolute', bottom: -4, right: -4, fontSize: 28, opacity: 0.35 }}>🌺</div>

      {/* Top accent */}
      <div style={{ fontSize: 19, marginBottom: 2 }}>💍</div>

      <div style={{ fontSize: 9, letterSpacing: 2.5, textTransform: 'uppercase', color: '#C2185B', marginBottom: 5 }}>
        Nikoh to'yiga taklif
      </div>

      <div style={{ fontSize: 20, fontWeight: 700, color: '#AD1457', lineHeight: 1.25, textAlign: 'center' }}>
        {groomName || 'Kuyov'} <span style={{ fontSize: 15, color: '#E91E63', margin: '0 6px' }}>&</span> {brideName || "Kelin"}
      </div>

      <div style={{
        width: 80, height: 1.5, margin: '7px 0',
        background: 'linear-gradient(90deg, transparent, #F06292, transparent)',
      }} />

      <div style={{ fontSize: 11, textAlign: 'center', lineHeight: 1.5, color: '#AD1457' }}>
        {date && <div style={{ fontWeight: 600 }}>{date}</div>}
        {time && <div>Soat: {time}</div>}
        {venue && <div style={{ fontWeight: 600, marginTop: 2 }}>{venue}</div>}
        {address && <div style={{ fontSize: 9.5, opacity: 0.8 }}>{address}</div>}
      </div>

      {msg && (
        <div style={{ fontSize: 8.5, fontStyle: 'italic', textAlign: 'center', color: '#C2185B', marginTop: 6, maxWidth: '78%' }}>
          {msg}
        </div>
      )}

      {qrValue && (
        <div style={{ position: 'absolute', bottom: '5mm', right: '5mm' }}>
          <QRCodeSVG value={qrValue} size={46} level="M" fgColor="#AD1457" bgColor="transparent" />
        </div>
      )}
    </div>
  );
}
